/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetaDataDto
 */
export interface MetaDataDto {
    /**
     * 
     * @type {number}
     * @memberof MetaDataDto
     */
    categoryPercentageOfWhole?: number;
    /**
     * 
     * @type {number}
     * @memberof MetaDataDto
     */
    categoryTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof MetaDataDto
     */
    categoryCurrency?: string | null;
}

/**
 * Check if a given object implements the MetaDataDto interface.
 */
export function instanceOfMetaDataDto(value: object): value is MetaDataDto {
    return true;
}

export function MetaDataDtoFromJSON(json: any): MetaDataDto {
    return MetaDataDtoFromJSONTyped(json, false);
}

export function MetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryPercentageOfWhole': json['categoryPercentageOfWhole'] == null ? undefined : json['categoryPercentageOfWhole'],
        'categoryTotal': json['categoryTotal'] == null ? undefined : json['categoryTotal'],
        'categoryCurrency': json['categoryCurrency'] == null ? undefined : json['categoryCurrency'],
    };
}

export function MetaDataDtoToJSON(json: any): MetaDataDto {
    return MetaDataDtoToJSONTyped(json, false);
}

export function MetaDataDtoToJSONTyped(value?: MetaDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryPercentageOfWhole': value['categoryPercentageOfWhole'],
        'categoryTotal': value['categoryTotal'],
        'categoryCurrency': value['categoryCurrency'],
    };
}

